import {
  Boxes, Building2, ShieldCheck, BellRing, Wrench, Users, ScanLine,
  TrendingDown, Repeat, MessagesSquare, PieChart, Zap, Sparkles,
  Paintbrush, Hammer, Bug, AirVent, Refrigerator, WashingMachine,
  Droplets, Flame, Home, Menu, X, ArrowRight, ArrowUpRight, Check,
  Mail, MapPin, FileText, Lock, Download, Trash2, CalendarCheck,
  BadgeCheck, IndianRupee, ChevronRight, Landmark, KeyRound,
  Apple, Play, Smartphone, ClipboardList, Wallet, PiggyBank,
} from "lucide-react";

const MAP = {
  Boxes, Building2, ShieldCheck, BellRing, Wrench, Users, ScanLine,
  TrendingDown, Repeat, MessagesSquare, PieChart, Zap, Sparkles,
  Paintbrush, Hammer, Bug, AirVent, Refrigerator, WashingMachine,
  Droplets, Flame, Home, Menu, X, ArrowRight, ArrowUpRight, Check,
  Mail, MapPin, FileText, Lock, Download, Trash2, CalendarCheck,
  BadgeCheck, IndianRupee, ChevronRight, Landmark, KeyRound,
  Apple, Play, Smartphone, ClipboardList, Wallet, PiggyBank,
};

export const Icon = ({ name, ...props }) => {
  const Cmp = MAP[name] || Boxes;
  return <Cmp {...props} />;
};
